module.exports = __webpack_public_path__ + "front/img/logo.ba3fd976.jpg";